import { classNames } from '@dimjs/utils';
import { CommonPropsWithChildren } from '../utils';
import './style.less';

export type AutoCenterProps = CommonPropsWithChildren;
/**
 * 1. 内容不够整行宽度时自动居中
 * 2. 内容达到满宽后保持正常的左对齐
 * @param props
 * @returns
 */
export const AutoCenter = (props: AutoCenterProps) => {
  return (
    <div className={classNames('v-auto-center', props.className)} style={props.style}>
      <div className={`v-auto-center-content`}>{props.children}</div>
    </div>
  );
};
